<ate-spinner [@inOutAnimation] *ngIf="isLoading$ | async"></ate-spinner>
<router-outlet></router-outlet>
<updates-available-modal></updates-available-modal>
